module.exports = require('./helpers/bundle-url').getBundleURL('f05n0') + "logo-dark.eefe0b7f.svg";